import { http } from './config'

export default {
  getAllVehicles: () => {
    return http.get('vehicles')
  },

  getFilteredVehicles: (params) => {
    return http.get('vehicles', { params })
  },

  getVehicleById: (vehicleId) => {
    return http.get('vehicles/' + vehicleId)
  },

  getVehicleByName: (vehicleName) => {
    return http.get('vehicles/by_vehicle_name/' + vehicleName)
  },

  createVehicle: (vehicleParams) => {
    return http.post('vehicles', {
      name: vehicleParams.name,
      vehicle_type_id: vehicleParams.vehicle_type_id.id,
      license_plate: vehicleParams.license_plate,
      integration_id: vehicleParams.integration_id,
    })
  },

  updateVehicle: (vehicleParams) => {
    return http.put('vehicles/' + vehicleParams.vehicleId, {
      name: vehicleParams.name,
      vehicle_type_id: vehicleParams.vehicle_type_id.id,
      license_plate: vehicleParams.license_plate,
      integration_id: vehicleParams.integration_id,
    })
  },

  deleteVehicle: (vehicleID) => {
    return http.delete('vehicles/' + vehicleID)
  },

  exportVehiclesReport: (name) => {
    return http.get(`vehicles/export_vehicles_report?name=${name}`)
  },

}
